import * as React from 'react';

import { DialogFooter } from 'src/components/resourceDialog/DialogFooter';
import { useProjectFileUploadPreviewDialog } from 'src/containers/ProjectFileUploadPreviewDialogV2/context/useProjectFileUploadPreviewDialog';
import * as copy from 'src/templates/copy';

export const ProjectFileUploadPreviewDialogFooter: React.VFC = () => {
  const { footerOptions } = useProjectFileUploadPreviewDialog();

  return (
    <DialogFooter
      footerOptions={footerOptions}
      nextButtonLabel={copy.components.fileUploadPreviewDialog.nextButton}
    />
  );
};
